import { render, staticRenderFns } from "./translateBtn.vue?vue&type=template&id=29b3bd5a&scoped=true"
import script from "./translateBtn.vue?vue&type=script&lang=js"
export * from "./translateBtn.vue?vue&type=script&lang=js"
import style0 from "./translateBtn.vue?vue&type=style&index=0&id=29b3bd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3bd5a",
  null
  
)

export default component.exports